import {RcfaStoppageCode as StoppageCode} from '@domain/shared'
import Check from '@mui/icons-material/Check'
import {Box, Button, Stack, TextField, Typography} from '@mui/material'
import {DateTimePicker} from '@mui/x-date-pickers'
import {Moment} from 'moment/moment'
import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {usePatchAnalysis} from '../../../hooks/usePatchAnalysis'
import {FEATURE_NAMESPACE} from '../../../localization'
import {SearchStoppageCode} from '../SearchStoppageCode'

export const CreateStoppageForm = ({
  cancelForm,
  analysisId
}: {
  cancelForm: () => void
  analysisId: number
}) => {
  const [customStoppage, setCustomStoppage] = useState<StoppageCode | null>(null)
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {mutateAsync: updateAnalysis} = usePatchAnalysis()

  const [item, setItem] = useState<{
    stoppageStart: string | null
    stoppageEnd: string | null
  }>({
    stoppageStart: null,
    stoppageEnd: null
  })

  const handleSubmit = async () => {
    await updateAnalysis({
      stoppageCode: customStoppage?.code,
      stoppageCodeType: customStoppage?.type,
      stoppageEnd: item.stoppageEnd ?? undefined,
      stoppageStart: item.stoppageStart ?? undefined,
      Id: analysisId
    })
    cancelForm()
  }

  return (
    <>
      <Box mb={4}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            fontWeight: 500,
            fontSize: 20,
            lineHeight: '24px'
          }}
        >
          Link to stoppage
        </Typography>
      </Box>
      <Stack gap={2}>
        <SearchStoppageCode
          value={customStoppage}
          onChange={(stoppage) => setCustomStoppage(stoppage)}
        />
        <Stack direction="row" spacing={2}>
          <DateTimePicker
            inputFormat="DD.MM.YYYY HH:mm"
            ampm={false}
            data-test-id="stoppage-start-input"
            label={t('analysis.new.stoppageStart')}
            onChange={(value: Moment | null) => {
              setItem((item) => ({
                ...item,
                stoppageStart: value ? value.toISOString() : value
              }))
            }}
            value={item.stoppageStart}
            disableFuture
            renderInput={(params) => <TextField variant="filled" size="small" {...params} />}
          />
          <DateTimePicker
            inputFormat="DD.MM.YYYY HH:mm"
            ampm={false}
            data-test-id="stoppage-end-input"
            label={t('analysis.new.stoppageEnd')}
            onChange={(value: Moment | null) => {
              setItem((item) => ({
                ...item,
                stoppageEnd: value ? value.toISOString() : value
              }))
            }}
            value={item.stoppageEnd}
            disableFuture
            renderInput={(params) => <TextField variant="filled" size="small" {...params} />}
          />
        </Stack>
      </Stack>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}
        mb={2}
        mt={2}
      >
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={cancelForm} data-test-id="stoppage-cancel-button">
            {t('buttons.cancel')}
          </Button>
          <Button
            startIcon={<Check />}
            color="primary"
            variant="contained"
            onClick={() => handleSubmit()}
            data-test-id="stoppage-create-button"
          >
            Link to stoppage
          </Button>
        </Box>
      </Box>
    </>
  )
}
